import { TFunction } from 'i18next'

export const WORK_N_DAY_TYPES = (t: TFunction<'translation', undefined>) => [
    { label: t('morning'), value: 0 },
    { label: t('afternoon'), value: 1 },
    { label: t('all-day'), value: 2 },
]

export const HOLIDAY_OPTIONS = (t: TFunction<'translation', undefined>) => [
    {
        label: t('schedule-saturday'),
        value: 'Lịch nghỉ thứ 7',
        color: 'success',
    },
    {
        label: t('schedule-remote'),
        value: 'Lịch làm việc remote',
        color: 'info',
    },
    {
        label: t('hung-vuong'),
        value: 'Nghỉ lễ giỗ tổ Hùng Vương 10/03 âm lịch',
        color: 'warning',
    },
    {
        label: t('newyear'),
        value: 'Nghỉ Tết Dương Lịch',
    },
    {
        label: t('lunar-newyear'),
        value: 'Nghỉ Tết Nguyên Đán',
    },
    {
        label: t('liberation-day'),
        value: 'Nghỉ Lễ Ngày Giải Phóng Miền Nam 30/04',
    },
    {
        label: t('labor-day'),
        value: 'Nghỉ Lễ Ngày Quốc Tế Lao Động 01/05',
    },
    {
        label: t('national-day'),
        value: 'Nghỉ Lễ Ngày Quốc Khánh 02/09',
    },
    {
        label: t('others'),
        value: 'Khác',
    },
]
